import { render, staticRenderFns } from "./CotizrFooter.vue?vue&type=template&id=9a64d5b4&"
import script from "./CotizrFooter.vue?vue&type=script&lang=js&"
export * from "./CotizrFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports